import global from "global";

export default () => {
  const {
    performance: {
      timing: { domContentLoadedEventEnd, navigationStart }
    }
  } = global;

  return domContentLoadedEventEnd - navigationStart;
};
